// Global Instructions Rule Applied!
//
// Configuration → Deal Origination service: which deal types are barred from
// the Deal Origination pipeline. Same fetch conventions as
// dealExecutionConfigService.
import { API_ROUTES, buildFullUrl, getBackendBaseUrl } from '../../../core/utils/endpoints.ts'
import {
  DealOriginationExclusionRow,
  validateDealOriginationExclusionRow
} from '../../../state_manager/data_models/deal_origination_admin_model.ts'

const BACKEND_BASE_URL = getBackendBaseUrl()

function authHeaders(accessToken: string | null): Record<string, string> {
  const headers: Record<string, string> = { 'Content-Type': 'application/json' }
  if (accessToken) headers['Authorization'] = `Bearer ${accessToken}`
  return headers
}

async function readJson(response: Response): Promise<any> {
  const body = await response.json().catch(() => ({}))
  if (!response.ok) {
    // The backend's error envelope key is `message` (handle_route_custom_error /
    // handle_route_error); `error` is the auth guard's.
    if (response.status === 401) throw new Error('Authentication failed - please log in again')
    throw new Error(body.message || body.error || `Request failed (${response.status})`)
  }
  return body
}

export const fetchDealOriginationExclusions = async (
  accessToken: string | null
): Promise<DealOriginationExclusionRow[]> => {
  const response = await fetch(
    buildFullUrl(BACKEND_BASE_URL, API_ROUTES.CONFIG.DEAL_ORIGINATION_EXCLUSIONS_LIST),
    {
      method: API_ROUTES.CONFIG.DEAL_ORIGINATION_EXCLUSIONS_LIST.method,
      headers: authHeaders(accessToken)
    }
  )
  const body = await readJson(response)
  const rows = (body.data || []) as DealOriginationExclusionRow[]
  validateDealOriginationExclusionRow(rows, { isArray: true })
  return rows
}

export const setDealOriginationExclusion = async (
  accessToken: string | null,
  dealTypeId: string,
  excluded: boolean
): Promise<void> => {
  const response = await fetch(
    buildFullUrl(BACKEND_BASE_URL, API_ROUTES.CONFIG.DEAL_ORIGINATION_EXCLUSIONS_SET),
    {
      method: API_ROUTES.CONFIG.DEAL_ORIGINATION_EXCLUSIONS_SET.method,
      headers: authHeaders(accessToken),
      body: JSON.stringify({ data: { deal_type_id: dealTypeId, excluded } })
    }
  )
  await readJson(response)
}
